import { attr } from '@ember-data/model';

export default function objectAttr() {
  return attr({ embedded: true })(...arguments);
}
